const $ = jQuery.noConflict();

class Slider {
	constructor(element, options) {
		this.element = element;
		this.sliderId = options.id;
		this.fireSlick();
	}

	fireSlick() {
		const id = `#${this.sliderId}`;

		$(id).slick({
            draggable: true,
            slidesToShow: 1,
            swipe: true,
            dots: true,
            arrows: false,
            autoplay: true
        });

        if ($(id).find('.slick-track').children().length < 2) {
            $(id).find('.slick-dots').remove();
        }
	}
}
export default Slider;


// WEBPACK FOOTER //
// ./assets/js/src/components/Slider.js